import { createContext } from 'react';
export var SearchContext = /*#__PURE__*/createContext(undefined);